"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.parseStyleParams = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _constants = require("./constants");
const findSiteColorByThemeName = (siteColors, themeName) => _lodash.default.find(siteColors, color => color.reference === themeName);
const recoveryColorsMap = {
  thumbnailButtonsColor: 'rgba(255,255,255,1)',
  thumbnailOverlayColor: 'rgba(0,0,0,0.4)'
};
const withRecoveryColors = colors => _lodash.default.mapValues(colors, ({
  value,
  themeName
} = {}, key) => {
  if (value && value.includes('NaN')) {
    return {
      themeName,
      value: recoveryColorsMap[key] || value
    };
  }
  return {
    value,
    themeName
  };
});
const parseStyleParams = ({
  styleParams,
  siteColors,
  siteTextPresets
}, isResponsive = false) => {
  const {
    booleans,
    colors,
    numbers,
    fonts
  } = styleParams;
  const themeToSiteColorMapping = (0, _lodash.default)(_constants.FALLBACK_COLOR_TO_SITE_COLOR_MAPPING).values().uniq().reduce((acc, themeName) => {
    const colorTheme = findSiteColorByThemeName(siteColors, themeName);
    return colorTheme ? {
      ...acc,
      [themeName]: {
        themeName,
        value: colorTheme.value
      }
    } : acc;
  }, {});
  const fallbackColors = _lodash.default.mapValues(_constants.FALLBACK_COLOR_TO_SITE_COLOR_MAPPING, theme => themeToSiteColorMapping[theme]);
  const fallbackFonts = _lodash.default.mapValues(isResponsive ? _constants.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING_RESPONSIVE : _constants.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING, fontKey => {
    if (siteTextPresets[fontKey]) {
      const {
        fontFamily,
        value,
        size,
        style,
        weight,
        editorKey
      } = siteTextPresets[fontKey];
      return {
        editorKey,
        family: fontFamily,
        size: parseInt(size, 10),
        preset: fontKey,
        style: {
          bold: weight !== 'normal',
          italic: style === 'italic'
        },
        value
      };
    }
    return {};
  });
  const mappedColors = _lodash.default.mapValues(colors, color => themeToSiteColorMapping[color.value] ? {
    ...color,
    value: themeToSiteColorMapping[color.value].value
  } : color);
  return {
    ...styleParams,
    booleans,
    colors: withRecoveryColors({
      ...fallbackColors,
      ...mappedColors
    }),
    numbers,
    fonts: {
      ...fallbackFonts,
      ...fonts
    }
  };
};
exports.parseStyleParams = parseStyleParams;
//# sourceMappingURL=parse.js.map